import "./App.css";
import "./i18n";
import { CalendarPreview } from "./pages/CalendarPreview";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LandingPage } from "./pages/LandingPage";
import { AppWrapper } from "./pages/AppWrapper";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppWrapper />}>
          <Route index element={<LandingPage />} />
          <Route path="calendar/gym/:gymId" element={<CalendarPreview />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
